import { createFileRoute } from '@tanstack/react-router'

import { preloadListCustomerGroups } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/customer-groups')({
	validateSearch: paginatedSearchWithSort(['name', 'createdAt']),
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder } }) => ({
		limit,
		offset,
		q,
		sortBy,
		sortOrder
	}),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder } }) =>
		await preloadListCustomerGroups(context, {
			query: {
				limit,
				offset,
				q,
				sortBy,
				sortOrder
			}
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.CustomerGroups.Title()
	}
})
